import React from 'react';

const PythonVsJavaScript: React.FC = () => {
  return (
    <div className="text-justify py-4">
      <p className="mb-4">
        Di era digital ini, <b>lebih dari 70% sekolah coding di Indonesia</b> menjadikan Python atau JavaScript sebagai bahasa pertama yang diajarkan kepada pemula. Lalu mana yang lebih cocok untuk pemula? Artikel ini akan mengupas perbandingan mendetail antara kedua bahasa pemrograman paling populer di dunia menurut <b>Stack Overflow Survey 2024</b>.
      </p>

      <h2 className="text-2xl font-bold mb-4">Profil Singkat Kedua Bahasa</h2>
      <div className="grid md:grid-cols-2 gap-6 mb-6">
        <div className="border rounded-lg p-4">
          <h3 className="text-xl font-semibold mb-3 text-center">🐍 Python</h3>
          <ul className="list-disc pl-6 space-y-2">
            <li>Diciptakan oleh Guido van Rossum (1991)</li>
            <li>Filosofi: &quot;Readability counts&quot;</li>
            <li>Digunakan oleh YouTube, Instagram, NASA</li>
            <li>Populer untuk: AI, Data Science, Backend</li>
          </ul>
        </div>
        <div className="border rounded-lg p-4">
          <h3 className="text-xl font-semibold mb-3 text-center">🟨 JavaScript</h3>
          <ul className="list-disc pl-6 space-y-2">
            <li>Dikembangkan oleh Brendan Eich (1995)</li>
            <li>Filosofi: &quot;The language of the web&quot;</li>
            <li>Digunakan oleh Netflix, Facebook, Spotify</li>
            <li>Populer untuk: Web Development, Mobile Apps</li>
          </ul>
        </div>
      </div>

      <h2 className="text-2xl font-bold mb-4">Perbandingan Kunci untuk Pemula</h2>
      <ol className="list-decimal pl-6 mb-6 space-y-6">
        <li>
          <p><strong>Kemudahan Sintaks</strong></p>
          <p className="mb-2">
            <b>Python</b> menggunakan indentasi untuk struktur kode, membuatnya mirip dengan bahasa manusia:
          </p>
          <pre className="bg-gray-100 p-3 rounded mb-2 whitespace-pre-wrap">
            {`# Contoh Python
if 5 > 2:
    print("Lima lebih besar dari dua")`}
          </pre>
          <p>
            <b>JavaScript</b> lebih fleksibel tetapi membutuhkan tanda kurung dan titik koma:
          </p>
          <pre className="bg-gray-100 p-3 rounded mb-2 whitespace-pre-wrap">
            {`// Contoh JavaScript
if (5 > 2) {
    console.log("Lima lebih besar dari dua");
}`}
          </pre>
          <p className="mt-2">
            <b>Pemenang:</b> Python lebih mudah dipahami pemula
          </p>
        </li>

        <li>
          <p><strong>Ekosistem Pembelajaran</strong></p>
          <p>
            <b>Python</b> memiliki dokumentasi sangat baik dengan tutorial resmi dan komunitas besar. Tools seperti Jupyter Notebook ideal untuk pembelajaran interaktif.
          </p>
          <p>
            <b>JavaScript</b> memiliki lebih banyak sumber belajar karena popularitas web development, tetapi seringkali membingungkan pemula dengan banyaknya framework (React, Vue, Angular).
          </p>
          <p className="mt-2">
            <b>Pemenang:</b> Seri, tergantung minat
          </p>
        </li>

        <li>
          <p><strong>Prospek Karir</strong></p>
          <p>
            <b>Python</b> mendominasi bidang kecerdasan buatan (AI), analisis data, dan otomasi dengan gaji rata-rata <b>Rp12-25 juta/bulan</b> untuk posisi entry-level di Indonesia.
          </p>
          <p>
            <b>JavaScript</b> tetap raja di pengembangan web dengan permintaan tinggi untuk full-stack developers (gaji <b>Rp10-20 juta/bulan</b>).
          </p>
          <p className="mt-2">
            <b>Pemenang:</b> Sesuai passion
          </p>
        </li>
      </ol>

      <h2 className="text-2xl font-bold mb-4">Kapan Memilih yang Mana?</h2>
      <div className="bg-blue-50 p-4 rounded-lg mb-6">
        <p className="font-semibold mb-2">💡 Pilih Python jika:</p>
        <ul className="list-disc pl-6 space-y-1">
          <li>Ingin fokus ke AI/Data Science</li>
          <li>Menginginkan sintaks paling mudah</li>
          <li>Tertarik dengan otomasi atau scripting</li>
        </ul>

        <p className="font-semibold mt-4 mb-2">💡 Pilih JavaScript jika:</p>
        <ul className="list-disc pl-6 space-y-1">
          <li>Bercita-cita menjadi web developer</li>
          <li>Ingin membuat proyek visual/interaktif</li>
          <li>Suka tantangan dengan ekosistem dinamis</li>
        </ul>
      </div>

      <h2 className="text-2xl font-bold mb-4">Kesimpulan</h2>
      <p className="mb-4">
        Baik Python maupun JavaScript sama-sama pilihan tepat untuk pemula dengan keunggulan berbeda. <b>85% programmer profesional</b> di survei kami mengaku mempelajari kedua bahasa ini selama karir mereka.
      </p>

      <p className="mb-6">
        Tips dari pakar: &quot;Mulailah dengan Python untuk memahami konsep dasar pemrograman, kemudian pelajari JavaScript ketika ingin membangun produk digital nyata&quot; - <b>Dr. Andi Wijaya, Head of Curriculum Coding Bootcamp Indonesia</b>.
      </p>

      <p>
        Ingin mencoba keduanya? Platform seperti <a href="https://www.freecodecamp.org" target="_blank" className="underline font-semibold text-defaultBlue">freeCodeCamp</a> menyediakan kursus gratis untuk kedua bahasa ini. Selamat memulai perjalanan coding!
      </p>
    </div>
  );
};

export default PythonVsJavaScript;